export const OFSE_SENDER_FIELDS = [
  'Sender ID',
  'Sender Name',
  'Sender Karma',
];

export const OFSE_RECEIVER_FIELDS = [
  'Receiver ID',
  'Receiver Name',
  'Receiver Karma',
  'Is Receiver an existing user?',
];
